import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";

import RouletteProvider from "../../../store/roulette/RouletteProvider";
import { useRoulette } from "../../../store/roulette/RouletteContext";
import { getShortBetType } from "../../../utils/tickets/printUtils";
import RouletteWheel from "../RouletteWheel";

const RouletteIframePage = (props) => {
    const [accessToken, setAccessToken] = useState("");

    useEffect(() => {
        const body = document.getElementById("lotto-body");
        if (body) {
            body.classList.add("bg-lotto-body");
        }

        const search = props?.location?.search || "";
        const params = new URLSearchParams(search);
        const token = params.get("accessToken") || "";

        if (!token) {
            localStorage.setItem(
                "isNotEnter",
                JSON.stringify({ isNotEnter: true })
            );
        } else {
            setAccessToken(token);
            localStorage.setItem("accessToken", token);

            if (!localStorage.getItem("hasReloaded")) {
                localStorage.setItem("hasReloaded", "true");
                window.location.reload();
            }
        }

        return () => {
            if (body) {
                body.classList.remove("bg-lotto-body");
            }
        };
    }, [props.location.search]);

    return (
        <RouletteProvider isIframe accessToken={accessToken}>
            <RouletteIframeContent {...props} />
        </RouletteProvider>
    );
};

const RouletteIframeContent = (props) => {
    const roulette = useRoulette();
    const { t } = props;
    const { oldResult, isWin } = roulette;

    return (
        <div
            id="roulette-iframe"
            className="wheel-container position-relative wheel-wrap"
            style={{ overflow: "hidden", display: "flex", alignItems: "center" }}
        >
            <div
                className="wheel d-flex align-items-center wheel-iframe"
                style={{ height: "90%", overflow: "hidden" }}
            >
                {isWin && (
                    <div
                        className="text-center w-100 position-absolute"
                        style={{ top: "0%", left: "50%", transform: "translateX(-50%)" }}
                    >
                        {oldResult?.underOverCode && oldResult?.oddEvenCode ? (
                            <div>
                                <b className="ff-batt">{oldResult?.result}</b>
                                <span> / </span>
                                <span className="kh-font-bold">
                  {t(
                      "labels:betPrefix.S_" +
                      getShortBetType(oldResult?.underOverCode)
                  )}
                </span>
                                <span> / </span>
                                <span className="kh-font-bold left-bet-roulette">
                  {t(
                      "labels:drawing.drawPrefix." + oldResult?.oddEvenCode
                  )}
                </span>
                                <span> / </span>
                                <span className="kh-font-bold left-bet-roulette">
                  {t("labels:drawing.drawPrefix." + oldResult?.colorCode)}
                </span>
                            </div>
                        ) : (
                            <div className="px-lg-4 mr-4 mr-lg-0 label-header" />
                        )}
                    </div>
                )}

                <RouletteWheel {...roulette} />
            </div>
        </div>
    );
};

export default withTranslation()(RouletteIframePage);